import React from 'react';
import { useNavigate } from 'react-router-dom';
import demoStrategies, { getMapMeta } from '../data/demoStrategies';
import '../styles/Demo.css';

const DemoPlaybook = () => {
  const navigate = useNavigate();
  const primaryDemoId = demoStrategies[0]?.id;

  return (
    <div className="demo-shell">
      <header className="demo-topbar">
        <div className="demo-brand" onClick={() => navigate('/landing')}>
          <img src="/assets/theboxlogo.png" alt="TheBox" />
          <div>
            <p className="demo-kicker">Interactive demo</p>
            <h1>See how TheBox works</h1>
          </div>
        </div>
        <div className="demo-actions">
          <button className="ghost-btn" onClick={() => navigate('/login')}>Sign in</button>
          <button className="primary-btn" onClick={() => navigate('/register')}>Start free trial</button>
        </div>
      </header>

      <section className="demo-hero-card">
        <div>
          <p className="eyebrow">Try it without an account</p>
          <h2>Move players, drop utils, draw paths — all in your browser.</h2>
          <p className="subtext">
            This sandbox uses mock data only. No Firebase sign-in required. When you like what you see, create a team to save for real.
          </p>
          <div className="hero-cta-row">
            <button className="primary-btn" onClick={() => navigate(primaryDemoId ? `/demo/${primaryDemoId}` : '/landing')}>
              Open interactive demo
            </button>
            <button className="secondary-btn" onClick={() => navigate('/register')}>
              Save this for real
            </button>
          </div>
          <p className="tiny-note">Changes you make here stay local to this browser only.</p>
        </div>
        <div className="demo-hero-preview">
          <div className="demo-preview-map">
            <span>Hardpoint • Summit</span>
            <img src="/assets/summ.jpg" alt="Summit demo preview" />
          </div>
          <div className="demo-preview-pill">Drag • Drop • Draw</div>
        </div>
      </section>

      <section className="demo-grid">
        {demoStrategies.map((strat) => {
          const mapMeta = getMapMeta(strat.mode, strat.map);
          const mapImage = mapMeta?.thumbnail || mapMeta?.image || '/assets/summ.jpg';
          return (
            <div key={strat.id} className="demo-card">
              <div className="demo-card-thumb">
                <img src={mapImage} alt={strat.map} />
                <div className="demo-card-chip">{strat.mode.toUpperCase()}</div>
              </div>
              <div className="demo-card-body">
                <p className="eyebrow">{strat.map.replaceAll('_', ' ')}</p>
                <h3>{strat.name}</h3>
                <p className="subtext">{strat.summary}</p>
                <div className="demo-chip-row">
                  {strat.highlights?.map((h) => (
                    <span key={h} className="chip">{h}</span>
                  ))}
                </div>
                <button className="primary-btn" onClick={() => navigate(`/demo/${strat.id}`)}>
                  Open demo
                </button>
              </div>
            </div>
          );
        })}
      </section>

      <section className="demo-footer-cta">
        <div>
          <h2>Ready to keep your plays?</h2>
          <p>Sign up to unlock saving, team sharing, and stats.</p>
        </div>
        <div className="hero-cta-row">
          <button className="primary-btn" onClick={() => navigate('/register')}>Create your team</button>
          <button className="ghost-btn" onClick={() => navigate('/login')}>Sign in</button>
        </div>
      </section>
    </div>
  );
};

export default DemoPlaybook;
